import { useEffect, useState } from "react";
import { useAccount } from "wagmi";

const networks = {
  ethereum: 1,
  polygon: 137,
  base: 8453,
  zora: 7777777,
  optimism: 10,
  arbitrum: 42161,
} as Record<string, number>;

export const useIsCollector = ({
  contractAddresses,
}: {
  contractAddresses: string[];
}): { isCollector?: boolean; error?: Error; isLoading: boolean } => {
  const { address, isConnected } = useAccount();
  const [isCollector, setIsCollector] = useState<boolean>(
    contractAddresses.length === 0
  );
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isConnected || !contractAddresses.length) return;
    let isCancelled = false;
    setIsLoading(true);

    const fetchData = async () => {
      try {
        const tokens = await fetch(
          `https://api.simplehash.com/api/v0/nfts/owners?chains=${Object.keys(
            networks
          ).join(
            ","
          )}&wallet_addresses=${address}&contract_addresses=${contractAddresses.join(
            ","
          )}&limit=50`,
          {
            headers: {
              "X-API-KEY": process.env.SIMPLEHASH_KEY,
            },
          }
        )
          .then((resp) => resp.json())
          .catch((e) => {
            console.error(e);
            if (!isCancelled) {
              setError(e instanceof Error ? e : new Error(e.toString()));
              setIsCollector(false);
              setIsLoading(false);
            }
          });
        setIsCollector(tokens.nfts.length > 0);
      } catch (err) {
        if (!isCancelled) {
          setIsCollector(false);
          setError(err instanceof Error ? err : new Error("An error occurred"));
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [isConnected, address]);

  return { isCollector, error, isLoading };
};
